import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { PATHS, ROUTES } from "../constants";
import { FourHundredFourComponent } from "./pages/four-hundred-four/four-hundred-four.component";
import { HomeComponent } from "./pages/home/home.component";
import { HomeDeComponent } from "./pages/home-de/home-de.component";
import { WhatComponent } from "./pages/what/what.component";
import { WhatDeComponent } from "./pages/what-de/what-de.component";
import { ProjectComponent } from "./pages/works/project/project.component";
import { WorksComponent } from "./pages/works/works.component";
import { WorksDeComponent } from "./pages/works-de/works-de.component";
import { BlogComponent } from "./pages/blog/blog.component";
import { PostComponent } from "./pages/blog/post/post.component";
import { IncubatorComponent } from "./pages/incubator/incubator.component";
import { NearshoringEnComponent } from "./pages/nearshoring-en/nearshoring-en.component";
import { NearshoringDeComponent } from "./pages/nearshoring-de/nearshoring-de.component";
import { LanguageAwareRedirectComponent } from "./components/language-aware-redirect/language-aware-redirect.component";
import { LanguageRedirectGuard } from "./guards/language-redirect.guard";

const routes: Routes = [
  {
    path: "",
    component: HomeComponent,
    pathMatch: "full",
  },
  {
    path: "en",
    redirectTo: "",
    pathMatch: "full",
  },
  // English home path is the empty path above
  {
    path: PATHS[ROUTES.HOME_DE],
    component: HomeDeComponent,
    canActivate: [LanguageRedirectGuard],
  },
  {
    path: PATHS[ROUTES.WORKS],
    canActivate: [LanguageRedirectGuard],
    children: [
      {
        path: "",
        component: WorksComponent,
        pathMatch: "full",
      },
      {
        path: ":project",
        component: ProjectComponent,
        runGuardsAndResolvers: "always",
      },
    ],
  },
  {
    path: PATHS[ROUTES.WORKS_DE],
    canActivate: [LanguageRedirectGuard],
    children: [
      {
        path: "",
        component: WorksDeComponent,
        pathMatch: "full",
      },
      {
        path: ":project",
        component: ProjectComponent,
        runGuardsAndResolvers: "always",
      },
    ],
  },
  {
    path: PATHS[ROUTES.WHAT],
    component: WhatComponent,
    canActivate: [LanguageRedirectGuard],
  },
  {
    path: PATHS[ROUTES.WHAT_DE],
    component: WhatDeComponent,
    canActivate: [LanguageRedirectGuard],
  },
  {
    path: PATHS[ROUTES.BLOG],
    canActivate: [LanguageRedirectGuard],
    children: [
      {
        path: "",
        component: BlogComponent,
        pathMatch: "full",
      },
      {
        path: ":postUri",
        component: PostComponent,
        runGuardsAndResolvers: "always",
      },
    ],
  },
  {
    path: PATHS[ROUTES.INCUBATOR],
    component: IncubatorComponent,
    canActivate: [LanguageRedirectGuard],
  },
  {
    path: PATHS[ROUTES.NEARSHORING_EN],
    component: NearshoringEnComponent,
    canActivate: [LanguageRedirectGuard],
  },
  {
    path: PATHS[ROUTES.NEARSHORING_DE],
    component: NearshoringDeComponent,
    canActivate: [LanguageRedirectGuard],
  },
  {
    path: PATHS[ROUTES.FOUR_HUNDRED_FOUR],
    component: FourHundredFourComponent,
  },
  {
    path: "**",
    component: FourHundredFourComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: "reload",
      relativeLinkResolution: "corrected",
      initialNavigation: "enabled",
      anchorScrolling: "enabled",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
